import { ReactComponent as Apple } from '../assets/kays-optotypes/apple.svg';
import { ReactComponent as Boot } from '../assets/kays-optotypes/boot.svg';
import { ReactComponent as Car } from '../assets/kays-optotypes/car.svg';
import { ReactComponent as Duck } from '../assets/kays-optotypes/duck.svg';
import { ReactComponent as House } from '../assets/kays-optotypes/house.svg';
import { ReactComponent as Star } from '../assets/kays-optotypes/star.svg';

export const kaysOptotypes = { apple: <Apple />, boot: <Boot />, car: <Car />, duck: <Duck />, house: <House />, star: <Star /> };
